/**
 * Mobile menu — animated slide-in panel.
 * Backdrop: opacity/visibility fade. Panel: translateX slide from right.
 * Hamburger close button: hamburger--collapse.is-active CSS transform → X.
 */

const backdrop = document.querySelector("[data-mobile-menu-backdrop]");

if (backdrop) {
    const closeBtns = backdrop.querySelectorAll("[data-mobile-menu-close]");
    const navLinks = backdrop.querySelectorAll(".mobile-menu-panel__nav a");
    const triggers = document.querySelectorAll(".menu-button:not([data-mobile-menu-close])");

    let isOpen = false;
    let closeTimer = null;

    const openMenu = () => {
        if (isOpen) return;
        isOpen = true;
        clearTimeout(closeTimer);

        backdrop.classList.add("is-visible");
        backdrop.setAttribute("aria-hidden", "false");
        document.body.style.overflowY = "hidden";

        triggers.forEach((t) => t.classList.add("is-active"));
        closeBtns.forEach((t) => t.classList.add("is-active"));
    };

    const closeMenu = () => {
        if (!isOpen) return;
        isOpen = false;

        backdrop.classList.remove("is-visible");
        backdrop.setAttribute("aria-hidden", "true");
        document.body.style.overflowY = "";

        triggers.forEach((t) => t.classList.remove("is-active"));
        closeBtns.forEach((t) => t.classList.remove("is-active"));
    };

    triggers.forEach((btn) => {
        btn.addEventListener("click", () => {
            isOpen ? closeMenu() : openMenu();
        });
    });

    closeBtns.forEach((btn) => btn.addEventListener("click", closeMenu));

    navLinks.forEach((link) => link.addEventListener("click", closeMenu));

    backdrop.addEventListener("click", (e) => {
        if (e.target === backdrop) closeMenu();
    });

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && isOpen) closeMenu();
    });

    window.addEventListener("resize", () => {
        if (window.innerWidth >= 768 && isOpen) closeMenu();
    });
}
